import { Box, Typography } from "@mui/material";

const LegendItem = ({ pinStyle, label }) => (
  <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        bgcolor: pinStyle.background,
        border: `2px solid ${pinStyle.borderColor}`,
        color: pinStyle.glyphColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontSize: 12,
        lineHeight: 1,
      }}>
      {pinStyle.glyphText}
    </Box>
    <Typography component="span" variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

export default LegendItem;
